const data = {
  title: "Floor 4-3",
  musicTrack: "MUSIC_WORLD4",
  theme: "GRAY",
  tilesWidth: 15,
  tilesHeight: 15,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 10,
      y: 2,
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 2,
    },
    {
      type: "FIRE",
      x: 4,
      y: 2,
    },
    {
      type: "FIRE",
      x: 6,
      y: 4,
    },
    {
      type: "WALL",
      x: 3,
      y: 4,
    },
    {
      type: "WALL",
      x: 1,
      y: 4,
    },
    {
      type: "WALL",
      x: 9,
      y: 4,
    },
    {
      type: "WALL",
      x: 11,
      y: 4,
    },
    {
      type: "FIRE",
      x: 6,
      y: 8,
    },
    {
      type: "FIRE",
      x: 4,
      y: 9,
    },
    {
      type: "FIRE",
      x: 4,
      y: 11,
    },
    {
      type: "TELEPORT",
      x: 10,
      y: 6,
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 6,
    },
    {
      type: "TELEPORT",
      x: 10,
      y: 10,
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 10,
    },
    {
      type: "WATER",
      x: 9,
      y: 1,
    },
    {
      type: "WATER",
      x: 9,
      y: 2,
    },
    {
      type: "WATER",
      x: 9,
      y: 3,
    },
    {
      type: "WATER",
      x: 10,
      y: 3,
    },
    {
      type: "WATER",
      x: 11,
      y: 3,
    },
    {
      type: "WATER",
      x: 11,
      y: 2,
    },
    {
      type: "WATER",
      x: 11,
      y: 1,
    },
    {
      type: "WATER",
      x: 10,
      y: 1,
    },
    {
      type: "WALL",
      x: 12,
      y: 4,
    },
    {
      type: "WALL",
      x: 12,
      y: 12,
    },
    {
      type: "FIRE",
      x: 5,
      y: 12,
    },
    {
      type: "FIRE",
      x: 6,
      y: 12,
    },
    {
      type: "FIRE",
      x: 7,
      y: 12,
    },
    {
      type: "WALL",
      x: 12,
      y: 3,
    },
    {
      type: "WALL",
      x: 12,
      y: 2,
    },
    {
      type: "WALL",
      x: 12,
      y: 1,
    },
    {
      type: "WALL",
      x: 13,
      y: 4,
    },
    {
      type: "WALL",
      x: 15,
      y: 4,
    },
    {
      type: "ICE",
      x: 9,
      y: 7,
    },
    {
      type: "ICE",
      x: 10,
      y: 7,
    },
    {
      type: "ICE",
      x: 11,
      y: 7,
    },
    {
      type: "ICE",
      x: 11,
      y: 6,
    },
    {
      type: "ICE",
      x: 11,
      y: 5,
    },
    {
      type: "ICE",
      x: 10,
      y: 5,
    },
    {
      type: "ICE",
      x: 9,
      y: 5,
    },
    {
      type: "ICE",
      x: 9,
      y: 6,
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 14,
    },
    {
      type: "TELEPORT",
      x: 14,
      y: 10,
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 4,
      direction: "UP",
    },
    {
      type: "WALL",
      x: 8,
      y: 12,
    },
    {
      type: "WALL",
      x: 8,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
    {
      type: "WALL",
      x: 5,
      y: 4,
    },
    {
      type: "WALL",
      x: 7,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 1,
    },
    {
      type: "WALL",
      x: 4,
      y: 3,
    },
    {
      type: "WALL",
      x: 8,
      y: 1,
    },
    {
      type: "WALL",
      x: 8,
      y: 3,
    },
    {
      type: "FIRE",
      x: 3,
      y: 13,
    },
    {
      type: "FIRE",
      x: 3,
      y: 14,
    },
    {
      type: "FIRE",
      x: 3,
      y: 15,
    },
    {
      type: "FIRE",
      x: 2,
      y: 15,
    },
    {
      type: "FIRE",
      x: 1,
      y: 15,
    },
    {
      type: "FIRE",
      x: 2,
      y: 13,
    },
    {
      type: "FIRE",
      x: 1,
      y: 13,
    },
    {
      type: "FIRE",
      x: 1,
      y: 14,
    },
    {
      type: "FIRE",
      x: 2,
      y: 14,
    },
    {
      type: "WALL",
      x: 1,
      y: 12,
    },
    {
      type: "WALL",
      x: 3,
      y: 12,
    },
    {
      type: "LOCK",
      x: 2,
      y: 12,
      color: "BLUE",
    },
    {
      type: "KEY",
      x: 14,
      y: 14,
      color: "BLUE",
    },
    {
      type: "CONVEYOR",
      x: 8,
      y: 2,
      direction: "LEFT",
    },
    {
      type: "WATER",
      x: 12,
      y: 9,
    },
    {
      type: "WATER",
      x: 12,
      y: 10,
    },
    {
      type: "WATER",
      x: 12,
      y: 11,
    },
    {
      type: "WATER",
      x: 13,
      y: 8,
    },
    {
      type: "WATER",
      x: 14,
      y: 8,
    },
    {
      type: "WATER",
      x: 15,
      y: 8,
    },
    {
      type: "WATER",
      x: 9,
      y: 12,
    },
    {
      type: "WATER",
      x: 10,
      y: 12,
    },
    {
      type: "WATER",
      x: 11,
      y: 12,
    },
    {
      type: "WATER",
      x: 12,
      y: 5,
    },
    {
      type: "WATER",
      x: 12,
      y: 7,
    },
    {
      type: "WATER",
      x: 12,
      y: 6,
    },
    {
      type: "WATER",
      x: 9,
      y: 8,
    },
    {
      type: "WATER",
      x: 10,
      y: 8,
    },
    {
      type: "WATER",
      x: 11,
      y: 8,
    },
    {
      type: "FIRE",
      x: 7,
      y: 8,
    },
    {
      type: "WALL",
      x: 8,
      y: 8,
    },
    {
      type: "WATER",
      x: 12,
      y: 8,
    },
    {
      type: "FIRE",
      x: 5,
      y: 8,
    },
    {
      type: "FIRE",
      x: 4,
      y: 8,
    },
    {
      type: "WATER",
      x: 13,
      y: 13,
    },
    {
      type: "WATER",
      x: 13,
      y: 14,
    },
    {
      type: "WATER",
      x: 13,
      y: 15,
    },
    {
      type: "WATER",
      x: 14,
      y: 15,
    },
    {
      type: "WATER",
      x: 14,
      y: 14,
    },
    {
      type: "WATER",
      x: 14,
      y: 13,
    },
    {
      type: "WATER",
      x: 15,
      y: 13,
    },
    {
      type: "WATER",
      x: 15,
      y: 14,
    },
    {
      type: "WATER",
      x: 15,
      y: 15,
    },
    {
      type: "WALL",
      x: 12,
      y: 13,
    },
    {
      type: "WALL",
      x: 12,
      y: 14,
    },
    {
      type: "WALL",
      x: 12,
      y: 15,
    },
    {
      type: "WALL",
      x: 4,
      y: 13,
    },
    {
      type: "WALL",
      x: 4,
      y: 14,
    },
    {
      type: "WALL",
      x: 4,
      y: 15,
    },
    {
      type: "WALL",
      x: 4,
      y: 12,
    },
    {
      type: "WALL",
      x: 13,
      y: 12,
    },
    {
      type: "WALL",
      x: 15,
      y: 12,
    },
    {
      type: "LOCK",
      x: 14,
      y: 12,
      color: "GREEN",
    },
    {
      type: "WALL",
      x: 8,
      y: 11,
    },
    {
      type: "WALL",
      x: 8,
      y: 10,
    },
    {
      type: "WALL",
      x: 8,
      y: 9,
    },
    {
      type: "WALL",
      x: 8,
      y: 7,
    },
    {
      type: "WALL",
      x: 8,
      y: 6,
    },
    {
      type: "WALL",
      x: 8,
      y: 5,
    },
    {
      type: "WALL",
      x: 8,
      y: 13,
    },
    {
      type: "WALL",
      x: 8,
      y: 14,
    },
    {
      type: "WALL",
      x: 8,
      y: 15,
    },
    {
      type: "FIRE",
      x: 3,
      y: 8,
    },
    {
      type: "FIRE",
      x: 1,
      y: 8,
    },
    {
      type: "FIRE",
      x: 2,
      y: 8,
    },
    {
      type: "FIRE",
      x: 4,
      y: 5,
    },
    {
      type: "FIRE",
      x: 4,
      y: 6,
    },
    {
      type: "FIRE",
      x: 4,
      y: 7,
    },
    {
      type: "FIRE",
      x: 4,
      y: 10,
    },
    {
      type: "FIRE_BOOTS",
      x: 2,
      y: 6,
    },
    {
      type: "KEY",
      x: 2,
      y: 10,
      color: "GREEN",
    },
    {
      type: "ICE_BOOTS",
      x: 2,
      y: 14,
    },
    {
      type: "TELEPORT",
      x: 10,
      y: 14,
    },
    {
      type: "TELEPORT",
      x: 14,
      y: 2,
    },
    {
      type: "WATER_PICKUP",
      x: 14,
      y: 6,
    },
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 9,
      enemyType: "ROAMING_ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 11,
      y: 9,
      enemyType: "ROAMING_ENEMY",
    },
  ],
};

export default data;
